import { TransactionStatus } from '../shared/models/transactions/transaction-status';

export class TransactionStatusUtil {
  static FindById(fullList: TransactionStatus[], statusId: number) {
    const status = fullList.find((x) => x.id === statusId);
    if (!status) {
      let s = new TransactionStatus();
      s.id = statusId;
      s.name = 'Unknown Status';

      return s;
    }

    return status;
  }
}
